import { render, staticRenderFns } from "./problem-handling.vue?vue&type=template&id=0483a272&scoped=true&"
import script from "./problem-handling.vue?vue&type=script&lang=js&"
export * from "./problem-handling.vue?vue&type=script&lang=js&"
import style0 from "./problem-handling.vue?vue&type=style&index=0&id=0483a272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483a272",
  null
  
)

export default component.exports